import { useQueries } from 'react-query';
import { isEmpty, keyBy, map } from 'lodash';

import { GetAttachmentContentResponseDto } from '@pimm/services/lib/store-inspections';
import { GetAttachmentById, GetReportAttachmentById } from '@pimm/services/lib/store-inspections/services';
import { StoreFormReport } from '../classes/store-form-report';

type GetLmsHierarchySummaryResult = {
  isPending: boolean;
  data: Record<string, GetAttachmentContentResponseDto>;
};

export const useGetAttachments = (_queries?: StoreFormReport['attachmentsIds'], _queryKey?: string): GetLmsHierarchySummaryResult => {
  const results = useQueries(
    map(_queries, _query => ({
      queryKey: ['GetAttachmentById', _query.id],
      queryFn: async () => {
        const query = _query.type === 'form' ? GetAttachmentById : GetReportAttachmentById;
        const attachment = await query({ id: _query.id });
        return attachment;
      },
      enabled: !!_query?.id,
    })),
  );

  const attachments = results.filter(_ => _.isSuccess && !!_.data).map(_ => _.data as GetAttachmentContentResponseDto);
  // If there are no attachment queries, do NOT block rendering
  const isPending = results.some(_ => _.isLoading);

  return {
    isPending,
    data: keyBy(attachments, 'id'),
  };
};
